
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/month_view/templates/day_popover"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='month_view_popover_content'>\n  <ul class='clndr-day-events-list'></ul>\n</div>\n";
},"useData":true});
    }).call(this);
  